import { Component, inject } from '@angular/core';
import { NttLinkButton } from '@ui/button';
import { PwaUpdateService } from '@core/services/pwa-update.service';

@Component({
  selector: 'ntt-update-prompt',
  templateUrl: './update-prompt.html',
  styleUrl: './update-prompt.scss',
  imports: [NttLinkButton],
})
export class UpdatePromptComponent {
  readonly updater = inject(PwaUpdateService);
}
